import * as c from '../constants/NavConstants'

export const setNavLink = (route, text) => ({ type: c.SET_NAV_LINK, payload: { route, text } })
export const unsetNavLink = (route, text) => ({ type: c.UNSET_NAV_LINK })
export const suppressNav = () => ({ type: c.SUPPRESS_NAV })
export const unSuppressNav = () => ({ type: c.UN_SUPPRESS_NAV })
export const suppressSchoolMenu = () => ({ type: c.SUPPRESS_SCHOOL_MENU })
export const unSuppressSchoolMenu = () => ({ type: c.UN_SUPPRESS_SCHOOL_MENU })
export const setReturnApp = returnApp => ({ type: c.SET_RETURN_APP, payload: returnApp })
